import { makeAutoObservable, runInAction } from "mobx";
import { type AttachmentClient } from "./attachmentClient";
import { AttachmentData, FilledCompanyAttachmentType } from "./attachmentTypes";

export class AttachmentStore {
  private _attachmentDataId?: string = undefined;

  constructor(private readonly _attachmentClient: AttachmentClient) {
    makeAutoObservable(this);
  }

  get attachmentDataId(): string | undefined {
    return this._attachmentDataId;
  }

  set attachmentDataId(value: string | undefined) {
    this._attachmentDataId = value;
  }

  attachFileInfo = async (companyId: string, fileId: string, directorId?: string): Promise<void> => {
    try {
      const attachmentResponse = await this._attachmentClient.attachFile(
        new AttachmentData({
          companyId,
          fileId,
          type: FilledCompanyAttachmentType.PROOF_OF_ADDRESS,
          directorId,
        }),
      );

      runInAction(() => {
        this._attachmentDataId = attachmentResponse.attachmentId;
      });
    } catch (error) {
      throw new Error(`Failed to attach file info: ${(error as Error).message}`, { cause: error });
    }
  };
}
